import { render, staticRenderFns } from "./Configuration.view.vue?vue&type=template&id=0a3a5999&"
import script from "./Configuration.view.vue?vue&type=script&lang=js&"
export * from "./Configuration.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports